import React from 'react';

import Text from '~/components/core/TextComponents/Text';

import type { CliveConfigTableSwitchColumnConfig } from './CliveConfigurationTable';
import CliveConfigTable from './CliveConfigurationTable';

const SWITCH_COLUMNS_CONFIG: CliveConfigTableSwitchColumnConfig[] = [
  {
    id: 'send_ai_data',
    label: 'Enable (Send AI Data)',
  },
  {
    id: 'claim_chat',
    label: 'Chat',
  },
  {
    id: 'process_email_attachments',
    label: 'Process & Upload Email Attachments',
  },
  {
    id: 'process_api_documents',
    label: 'Process API Documents',
  },
  {
    id: 'create_document_with_defaults_on_failure',
    label: 'Create Document with Defaults on Failure',
  },
  {
    id: 'skip_defaults_validation_on_classify_upload',
    label: 'Skip Defaults Validation on Classify & Upload',
  },
  {
    id: 'fnol_to_claim_stp',
    label: 'FNOL to Claim STP',
  },
  {
    id: 'clive_insights_claim_tab',
    label: 'Claim Insights Tab',
  },
  {
    id: 'external_chat_api',
    label: 'External Chat API',
  },
  {
    id: 'web_search_in_chat',
    label: 'Web Search in Chat',
  },
];

const CliveConfigurationTab: React.FC = () => {
  return (
    <div>
      <Text variant={Text.VARIANTS.LG} weight={Text.WEIGHTS.SEMI_BOLD} className="mb-12">
        Sub-Organizations Configuration
      </Text>
      <CliveConfigTable config_switch_columns={SWITCH_COLUMNS_CONFIG} />
    </div>
  );
};

export default CliveConfigurationTab;
